import ServicePage from '../../components/service/ServicePage'

export default function Siebdruck() {
  return <ServicePage service="screen" lang="de" />
}
